module.exports = __webpack_public_path__ + "img/32-LungFlute.f26b0907.jpg";